<template>
  <form @submit.prevent="submit" class="program-deliver-details-weighnow">
    <smd-one-col-layout content-styles="view-pharmacy-orders-delivery-details__content">
      <full-screen-loader v-if="loading" :whiteBg="true"/>

      <div v-if="!loading" :class="{'view-pharmacy-orders-delivery__inner': desktopView}">

        <div class="smd-form__row m-b-25">
          <form-required-note/>
        </div>

        <!--   Delivery Details   -->
        <div class="smd-form__row">
          <text-string label-id="txt095"/>
        </div>

        <!--   Contact Person   -->
        <div class="smd-form__row m-b-10">
          <div class="smd-form__col">
            <label required
                   input-label
                   for="contactPerson"
                   :error="$v.contactPerson.$invalid && $v.contactPerson.$error">
              {{ getElementString('txt101') }}
              <span class="form-text-error"
                    v-if="$v.contactPerson.$invalid && $v.contactPerson.$error">
              {{ validationErrors.contactPerson }}
            </span>
            </label>
            <input type="text"
                   id="contactPerson"
                   v-model="$v.contactPerson.$model"
                   :placeholder="getElementString('txt105')">
          </div>
        </div>


        <!--   Mobile No.   -->
        <div class="smd-form__row m-b-30">
          <div class="smd-form__col">
            <label required
                   input-label
                   for="mobilenumber"
                   :error="$v.mobilenumber.$invalid && $v.mobilenumber.$error">
              {{ getElementString('txt102') }}
              <span class="form-text-error"
                    v-if="$v.mobilenumber.$invalid && $v.mobilenumber.$error">
              {{ validationErrors.mobilenumber }}
            </span>
            </label>
            <smd-phone-input v-model="$v.mobilenumber.$model"
                             id="mobilenumber"
                             ref="mobilenumber"
                             placeholder="9#########"
                             :error="$v.mobilenumber.$invalid && $v.mobilenumber.$error"
                             :has-value="!$v.mobilenumber.$error"/>
          </div>
        </div>

        <!--   House # / Building, Street, Barangay   -->
        <div class="smd-form__row m-b-20">
          <div class="smd-form__col">
            <label required
                   input-label
                   for="street"
                   :error="$v.street.$invalid && $v.street.$error">
              {{ getElementString('txt103') }}
              <span class="form-text-error"
                    v-if="$v.street.$invalid && $v.street.$error">
              {{ validationErrors.street }}
            </span>
            </label>
            <input v-model="$v.street.$model"
                   type="text"
                   id="street"
                   :placeholder="getElementString('txt103')"
                   :error="$v.street.$invalid && $v.street.$error"
                   :has-value="!$v.street.$invalid">
          </div>
        </div>

        <!--   Select City   -->
        <div class="smd-form__row m-b-10">
          <div class="smd-form__col">
            <label input-label
                   required>
              {{ getElementString('txt620') }}
            </label>
            <smd-list-selection-panel :has-text-string="true"
                                      :title="computedCityTitle"
                                      @selected="showCityModal"
                                      @change="showCityModal">
              <text-string slot="placeholder"
                           v-if="computedCityPlaceholder"
                           :label-id="computedCityPlaceholder"/>
              <span class="Title3 gray-900"
                    v-else
                    slot="title">
                    {{ computedCityTitle }}
                  </span>
              <span class="ns-icon-ico039 ns-large-icon" slot="icon">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                  </span>
            </smd-list-selection-panel>
          </div>
        </div>

        <div class="smd-form__row m-b-20 city-note">
          <text-string label-id="txt1430"/>
        </div>

        <!--   Notes/Landmarks/Map Pin   -->
        <div class="smd-form__row m-b-20">
          <div class="smd-form__col">
            <label input-label
                   for="buildingname">
              {{ getElementString('txt104') }}
            </label>
            <input v-model="buildingname"
                   type="text"
                   id="buildingname"
                   :placeholder="getElementString('txt104')">
          </div>
        </div>

        <div class="smd-form__row m-t-40 m-b-25">
          <text-string label-id="txt092"/>
        </div>

        <!-- partner images -->
        <div class="partners m-b-30">
          <img src="~@/assets/images/pharmacies/ico048.svg" alt="NS Pharmacy Logo">
          <img src="~@/assets/images/pharmacies/img047.png" alt="EduCare Logo">
          <img src="~@/assets/images/pharmacies/img041.png" alt="Southstar Drug Logo">
        </div>

        <!-- operational hours -->
        <div class="smd-form__row operational-hours m-b-30">
          <div class="smd-form__col">
            <text-string label-id="txt051" class="m-b-5"/>
            <div>
              <p class="Body1">Monday - Friday: 9am-5pm</p>
              <p class="Body1">Saturday: 8am-4pm</p>
            </div>
            <div>
              <span class="Label1 gray-400 m-b-5">Same-day Delivery Cutoff</span>
              <p class="Body1">Monday - Friday: 5pm</p>
              <p class="Body1">Saturday: 4pm</p>
            </div>
          </div>
        </div>

        <div class="educare-terms m-b-30">
          <smd-checkbox v-model="educareTerms">
            <div>
              <p class="Title3">I want to join the Educare Program</p>
              <p class="Body1">By ticking on the checkbox, you accept <span class="Hyperlink2 dodgerBlue" @click.prevent="openEducareTermsModal">Educare's Terms & Conditions</span></p>
            </div>
          </smd-checkbox>
        </div>

        <div class="delivery-details__terms">
          <!-- <text-string label-id="txt192"/> -->
          <p class="Paragraph1 text-center">
            By pressing FINISH ORDER, you accept the <span class="Hyperlink2 dodgerBlue" @click.prevent="openTermsModal">Terms & Conditions</span>
          </p>
        </div>

        <div v-if="error" class="delivery-details__error m-t-15">
          <smd-note>{{ error }}</smd-note>
        </div>

        <div class="view-pharmacy-orders-delivery__footer-btn m-t-75"
             v-if="desktopView">
          <div class="smd-form__row">
            <smd-btn section="10"
                     variant="left-enabled"
                     @click="setActiveStep($options.PHARMACY_ORDERS_DISCOUNT)">
              <text-string label-id="txt109"/>
            </smd-btn>
            <smd-btn section="10"
                     type="submit"
                     :disabled="disableSubmit"
                     :variant="computedVariant">
              <text-string label-id="txt110"/>
            </smd-btn>
          </div>
        </div>
      </div>

      <!--   Bottom Nav   -->
      <div slot="bottom-nav"
           v-if="!desktopView">
        <div class="smd-form__row">
          <smd-btn section="2"
                   variant="left-enabled"
                   @click="setActiveStep($options.PHARMACY_ORDERS_DISCOUNT)">
            <text-string label-id="txt109"/>
          </smd-btn>
          <smd-btn section="2"
                   type="submit"
                   :disabled="disableSubmit"
                   :variant="computedVariant">
            <text-string label-id="txt110"/>
          </smd-btn>
        </div>
      </div>
    </smd-one-col-layout>
  </form>
</template>

<script>
  import {mapFields} from "vuex-map-fields";
  import {Reference} from "smd-vue-scaffold";
  import ModalCityList from '@/modals/modal-city-list';
  import ModalTermsAndConditionsWeighNow from '@/modals/modal-terms-and-conditions-weighnow';
  import ModalEducareTermsAndConditions from '@/modals/modal-educare-terms-and-conditions';
  import MedicineOrdersDeliveryDetailsMixin from '@/mixins/services/medicine-orders-delivery-details-mixin';

  import {
    getCityValue,
  } from "@/utils";

  import {
  DEFAULT_PHARMACIES,
  } from '@/reference/medicine';

  export default {
    name: 'program-view-pharmacy-orders-delivery-details-weighnow',
    mixins: [MedicineOrdersDeliveryDetailsMixin],
    computed: {
      ...mapFields({
        educareTerms: 'opt_in.educare',
        termsAgreed: 'termsAgreed',
        novoTermsAgreed: 'novoTermsAgreed',
        partnercode: 'partnercode',
      }),
    },
    mounted() {
      this.partnercode = DEFAULT_PHARMACIES.NS_PHARMACY;
    },
    methods: {
      showCityModal() {
        this.$modal.open({
          component: ModalCityList,
          size: this.$isMobile ? Reference.SmdModalSizes.xs : Reference.SmdModalSizes.sm,
          position: !this.$isMobile ? 'detached' : '',
          props: {
            existingSelectedCity: this.cityObject,
            filterCities: {
              filterBy: 'region',
              value: ['National Capital Region (NCR)'],
            },
          },
          onClose: (cityObject) => {
            this.cityObject = cityObject;
            this.city = getCityValue(cityObject);
          },
        })
      },
      openTermsModal() {
        this.$modal.open({
          component: ModalTermsAndConditionsWeighNow,
          position: 'detached auto-height',
          size: this.$isMobile ? Reference.SmdModalSizes.xs : Reference.SmdModalSizes.sm,
          closeOnBackdrop: false,
        });
      },
      openEducareTermsModal() {
        this.$modal.open({
          component: ModalEducareTermsAndConditions,
          position: 'detached auto-height',
          size: this.$isMobile ? Reference.SmdModalSizes.xs : Reference.SmdModalSizes.sm,
          closeOnBackdrop: false,
        });
      },
      submit() {
        if (!this.termsAgreed || !this.novoTermsAgreed) {
          this.error = 'Terms and conditions are not accepted.';
        } else {
          this. error = null;
          this.submitOrder();
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/styles/util.scss";

  .program-deliver-details-weighnow {
    .partners {
      @include make-grid(repeat(2, minmax(50px, 100px)), repeat(2, minmax(min-content, max-content)), 37px, 25px, justify-content-center);
      justify-items: center;

      :first-child {
        grid-row: 1 / 2;
        grid-column: 1 / -1;

        transform: scale(1.4);
        max-width: 150px;
      }

      &> :nth-child(2) {
        border: 1px solid #E1E1E1;
      }

      &>img:not(:first-child) {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .educare-terms {
      @include box-shadow();
      border-radius: 10px;
      padding: 12px;

      > .smd-checkbox {
        color: color(dark, brand);
      }
    }

    .city-note {
      @extend %layout--flex-row-center-xy;
      background-color: rgba(255, 199, 14, 0.2);
      border-radius: 5px;
      padding: 10px;
      color: color(mustard, brand);
      text-align: center;
    }
  }

  .delivery-details__error .smd-note {
    color: color(white, text);
    background-color: color(crimson, brand);
  }
</style>
